import React from "react";

export default function FILTVChannelTransition({ visible, channel }) {
    if (!visible || !channel) return null;

    return (
        <div className="absolute inset-0 bg-black/95 z-50 flex flex-col items-center justify-center">
            <div className="text-5xl sm:text-6xl animate-pulse">📺</div>

            <div className="mt-4 sm:mt-6 text-3xl sm:text-4xl font-bold">LCN {channel.lcn}</div>

            <div className="mt-2 sm:mt-3 text-lg sm:text-xl">
                {channel.emoji} {channel.title}
            </div>

            <div className="mt-6 sm:mt-8 text-zinc-400 text-sm tracking-wide">
                Switching Channel...
            </div>
        </div>
    );
}
